import styled from "styled-components";
import { colors } from "../../../../../theme/theme";

export const TreeTableCard = styled.div`
    color: ${colors.greyscale.darker_grey};
    font-size: 16px;

    .p-treetable .p-treetable-thead{
        display: none;
    }

    .p-treetable .p-treetable-thead .pi{
        font-size: 12px;
    }

    .p-treetable .p-treetable-tbody > tr{
        background: ${colors.mainColors.white_lilac};
        margin-bottom: 5px;
        cursor: default;
    }

    .p-treetable .p-treetable-tbody > tr > td{
        border: 2px solid white;
        padding: 0.3rem 0.3rem;
    }

    .p-treetable .p-treetable-tbody .pi{
        font-weight: bold;
    }

    .sm-visible {
        display: table-cell;
    }    
    
    @media screen and (max-width: 40em) {
        .sm-invisible {
            display: none;
        }

        .sm-text{
            width: 60% !important;
        }

        .sm-actions{
            width: 10% !important;
        }
    
        .sm-visible {
            display: none;
            margin-right: .5rem;
        }
    }
`